import { useRef } from "react";
import { Shield, Sparkles, Check } from "lucide-react";
import { ScoreRing } from "@/components/Chips";
import { useParallax } from "@/components/landing/Reveal";

const tilt = (y) => `rotateX(${Math.max(16 - y * 0.03, 4)}deg) rotateZ(-1deg)`;

const ROWS = [
  [34, "Stunning Gorgeous Vintage Floral Dress - Perfect Unique Gift", "red"],
  [48, "Cat Mom Shirt, Cat Mom Gift, Funny Cat Mom Shirt, Cat Shirt", "red"],
  [63, "Retro Sunset Ceramic Coffee Mug", "yellow"],
  [71, "Vintage 1970s Paisley Silk Scarf", "yellow"],
  [88, "Vintage 1960s Enamel Flower Brooch, Gold Tone Pin", "green"],
];
const DOT = { red: "bg-rose-300 shadow-[0_0_10px_#fda4af]", yellow: "bg-amber-200 shadow-[0_0_10px_#fde68a]", green: "bg-emerald-300 shadow-[0_0_10px_#6ee7b7]" };

const Window = () => (
  <div className="glass hairline overflow-hidden rounded-[26px] border p-3 sm:p-5">
    <div className="flex items-center gap-2 px-1 pb-4">
      <span className="h-2.5 w-2.5 rounded-full bg-white/15" /><span className="h-2.5 w-2.5 rounded-full bg-white/15" /><span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      <span className="ml-3 whitespace-nowrap text-xs text-muted-foreground">Health report</span>
      <span className="ml-auto whitespace-nowrap rounded-full border border-white/10 px-2.5 py-0.5 text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Preview<span className="hidden sm:inline"> · sample listings</span></span>
    </div>
    <div className="grid grid-cols-1 gap-3 md:grid-cols-[200px_minmax(0,1fr)_290px]">
      <div className="hidden md:flex flex-col items-center justify-center rounded-2xl border border-white/[0.06] bg-white/[0.025] p-5">
        <ScoreRing score={61} size={120} stroke={7} label="avg score" />
        <div className="mt-5 grid w-full grid-cols-3 gap-1 text-center font-mono text-[11px]">
          <span className="rounded-lg bg-rose-400/10 py-1 text-rose-200">68</span>
          <span className="rounded-lg bg-amber-300/10 py-1 text-amber-100">167</span>
          <span className="rounded-lg bg-emerald-400/10 py-1 text-emerald-200">65</span>
        </div>
      </div>
      <div className="min-w-0 rounded-2xl border border-white/[0.06] bg-white/[0.025] p-2 sm:p-3">
        <p className="px-2 pb-2 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Fix these first</p>
        {ROWS.map(([s, t, b]) => (
          <div key={t} className="flex items-center gap-3 rounded-xl px-2 py-2.5 odd:bg-white/[0.02]">
            <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT[b]}`} />
            <span className="flex-1 truncate text-left text-[13px] text-foreground/85">{t}</span>
            <span className="font-mono text-xs text-muted-foreground">{s}</span>
          </div>
        ))}
      </div>
      <div className="hidden md:block rounded-2xl border border-[#8B7CFF]/25 bg-[#8B7CFF]/[0.06] p-4 text-left">
        <p className="text-[10px] uppercase tracking-[0.18em] text-[#C2BAFF]">Proposed fix</p>
        <p className="mt-3 text-[12px] text-muted-foreground line-through decoration-rose-300/50">Stunning Gorgeous Vintage Floral Dress - Perfect Unique Gift</p>
        <p className="mt-1.5 text-[13px] text-foreground">Vintage 1970s Floral Midi Dress, Blue Rayon</p>
        <p className="mt-2 flex gap-1.5 text-[11px] text-muted-foreground"><Sparkles className="h-3 w-3 shrink-0 text-[#8B7CFF]" />Clear nouns first; subjective words removed.</p>
        <div className="mt-3 flex flex-wrap gap-1">
          {["vintage dress", "70s midi dress", "floral rayon", "boho dress"].map((t) => (
            <span key={t} className="rounded-full border border-[#5EE6D0]/30 bg-[#5EE6D0]/[0.08] px-2 py-0.5 text-[10px] text-[#B8F5EA]">{t}</span>
          ))}
          <span className="px-1 font-mono text-[10px] text-muted-foreground">13/13</span>
        </div>
        <div className="btn-aurora mt-4 inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-[12px]"><Check className="h-3.5 w-3.5" />Approve &amp; push</div>
      </div>
    </div>
  </div>
);

export const ProductMockup = () => {
  const ref = useRef(null);
  useParallax(ref, tilt);
  return (
  <div className="relative mx-auto mt-12 max-w-6xl px-5 sm:mt-16 sm:px-8 [perspective:2200px]" aria-hidden="true">
    <div className="pointer-events-none absolute inset-x-10 top-16 h-2/3 rounded-full bg-[radial-gradient(closest-side,rgba(139,124,255,0.45),rgba(94,230,208,0.12),transparent)] blur-3xl" />
    <div className="float-slow">
      <div ref={ref} className="relative" style={{ transform: tilt(0), transformStyle: "preserve-3d" }}>
        <Window />
        <div className="absolute -right-2 -top-6 sm:-right-6 sm:-top-8 flex items-center gap-2 rounded-full border border-[#E9C98B]/45 bg-[#15130C]/80 px-4 py-2 text-sm text-[#F3DDAE] shadow-[0_0_40px_-6px_rgba(233,201,139,0.55)] backdrop-blur-md" style={{ transform: "translateZ(80px)" }}>
          <Shield className="h-4 w-4" />Protected bestseller
        </div>
      </div>
    </div>
  </div>
  );
};
